import styled from 'styled-components';

export const Container = styled.div`
  height: 560px; /* igual ao mapa */
  background: #fff;
  border-radius: 0.75rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const Header = styled.div`
  padding: 1rem;
  border-bottom: 1px solid #dee2e6;
`;

export const ScrollArea = styled.div`
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  padding: 1rem;
`;

export const Footer = styled.div`
  padding: 1rem;
  border-top: 1px solid #dee2e6;
`;

export const PointCard = styled.div`
  border: 1px solid #dee2e6;
  border-radius: 0.75rem;
  padding: 0.75rem;
  margin-bottom: 1rem;
  background-color: #fff;
`;

export const PointHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.4rem;
`;

export const PointLetter = styled.div`
  width: 28px;
  height: 28px;
  font-weight: bold;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 0.9rem;
  margin-right: 0;
  flex-shrink: 0;
`;

export const PointInfo = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

export const PointTitleLine = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 0.85rem;
`;

export const PointDates = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 1 1 auto;
  flex-wrap: nowrap;
  gap: 3px;
  min-width: 0;
  margin-left: 0.25rem;
  padding: 4px 2px;
  border-radius: 6px;
  font-size: 0.7rem;
  color: #6c757d;
  font-weight: 500;
  line-height: 1.25;
  text-align: right;
  white-space: nowrap;
  overflow-wrap: normal;
`;

export const PointAddress = styled.div`
  font-size: 0.85rem;
  font-weight: 500;
  margin-top: 0.25rem;
  min-width: 0;
  overflow-wrap: anywhere;
`;

export const DeleteBtn = styled.button`
  background: none;
  border: none;
  color: #f44336;
  cursor: pointer;
  margin-left: 0;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #d32f2f;
  }
`;
